import Button from '@atoms/Button/Button';
import Text from '@atoms/Text/Text';
import { ICounter } from '@models/ICounter';

const Counter = ({
  label,
  count,
  areaSize,
  areaLabel,
  onChange,
  increaseAriaLabel = 'Increase Count',
  decreaseAriaLabel = 'Decrease Count',
}: ICounter) => {
  return (
    <div className="tw-flex tw-w-fit tw-flex-col">
      <Text variant="label-12" className="tw-py-2 tw-text-grey-70">
        {label} ({`-${areaSize}${areaLabel}`})
      </Text>
      <div className="tw-flex tw-items-center tw-rounded tw-border tw-border-grey-60">
        <Button
          variant="link"
          iconName="minus"
          aria-label={decreaseAriaLabel}
          onClick={() => onChange(Math.max(0, count - 1))}
          contentClasses="md:!tw-p-1"
          buttonClasses="tw-border-r tw-rounded-none"
        />

        <Text className="tw-px-6 tw-py-2.5 md:tw-py-3.5">
          {count.toString()}
        </Text>

        <Button
          variant="link"
          iconName="plus"
          aria-label={increaseAriaLabel}
          onClick={() => {
            const newValue = Math.min(99, count + 1);
            onChange(newValue);
          }}
          contentClasses="md:!tw-p-1"
          buttonClasses="tw-border-l tw-rounded-none"
        />
      </div>
    </div>
  );
};

export default Counter;
